/* Basic opt-in analytics consent for GA4 and Microsoft Clarity. */
(function () {
    const storageKey = 'ostvk-analytics-consent';
    const root = document.querySelector('[data-consent-root]');
    if (!root) return;

    const acceptButton = root.querySelector('[data-consent-accept]');
    const rejectButton = root.querySelector('[data-consent-reject]');
    const preferenceButtons = document.querySelectorAll('[data-consent-preferences]');
    const googleAnalyticsId = (root.dataset.googleAnalyticsId || '').trim();
    const microsoftClarityId = (root.dataset.microsoftClarityId || '').trim();
    let analyticsLoaded = false;

    function readChoice() {
        try {
            const value = localStorage.getItem(storageKey);
            return value === 'accepted' || value === 'rejected' ? value : null;
        } catch (error) {
            return null;
        }
    }

    function saveChoice(value) {
        try {
            localStorage.setItem(storageKey, value);
        } catch (error) {
            // Consent still applies to the active page when storage is unavailable.
        }
    }

    function googleConsent(value) {
        if (typeof window.gtag !== 'function') return;
        window.gtag('consent', 'update', {
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
            analytics_storage: value,
        });
    }

    function clarityConsent(value) {
        if (typeof window.clarity !== 'function') return;
        window.clarity('consentv2', {
            ad_Storage: 'denied',
            analytics_Storage: value,
        });
    }

    function eraseClarityConsent() {
        if (typeof window.clarity !== 'function') return;
        window.clarity('consent', false);
    }

    function loadGoogleAnalytics() {
        if (!googleAnalyticsId || document.querySelector('[data-ostvk-ga4]')) return;

        window.dataLayer = window.dataLayer || [];
        window.gtag = window.gtag || function () {
            window.dataLayer.push(arguments);
        };
        window.gtag('consent', 'default', {
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
            analytics_storage: 'granted',
        });
        window.gtag('js', new Date());
        window.gtag('config', googleAnalyticsId, {
            linker: {
                domains: ['docs.ostvk.how', 'vault.ostvk.how'],
            },
        });

        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(googleAnalyticsId);
        script.dataset.ostvkGa4 = 'true';
        document.head.appendChild(script);
    }

    function loadClarity() {
        if (!microsoftClarityId || document.querySelector('[data-ostvk-clarity]')) return;

        window.clarity = window.clarity || function () {
            (window.clarity.q = window.clarity.q || []).push(arguments);
        };
        clarityConsent('granted');

        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.clarity.ms/tag/' + encodeURIComponent(microsoftClarityId);
        script.dataset.ostvkClarity = 'true';
        document.head.appendChild(script);
    }

    function loadAnalytics() {
        if (analyticsLoaded) return;
        analyticsLoaded = true;
        loadGoogleAnalytics();
        loadClarity();
    }

    function clearAnalyticsCookies() {
        const names = document.cookie.split(';').map(function (cookie) {
            return cookie.split('=')[0].trim();
        }).filter(function (name) {
            return name === '_ga' || name.indexOf('_ga_') === 0 || name === '_clck' || name === '_clsk';
        });
        const hostParts = window.location.hostname.split('.');
        const domains = ['', window.location.hostname, hostParts.length > 1 ? '.' + hostParts.slice(-2).join('.') : ''];

        names.forEach(function (name) {
            domains.forEach(function (domain) {
                const domainPart = domain ? '; domain=' + domain : '';
                document.cookie = name + '=; Max-Age=0; path=/' + domainPart + '; SameSite=Lax';
            });
        });
    }

    function showPreferences() {
        root.hidden = false;
        document.documentElement.classList.add('has-consent-dialog');
        acceptButton.focus();
    }

    function closePreferences() {
        root.hidden = true;
        document.documentElement.classList.remove('has-consent-dialog');
    }

    function accept() {
        saveChoice('accepted');
        loadAnalytics();
        googleConsent('granted');
        clarityConsent('granted');
        closePreferences();
    }

    function reject() {
        saveChoice('rejected');
        googleConsent('denied');
        clarityConsent('denied');
        eraseClarityConsent();
        clearAnalyticsCookies();
        closePreferences();
    }

    acceptButton.addEventListener('click', accept);
    rejectButton.addEventListener('click', reject);
    preferenceButtons.forEach(function (button) {
        button.addEventListener('click', showPreferences);
    });

    if (readChoice() === 'accepted') {
        loadAnalytics();
    } else if (readChoice() !== 'rejected') {
        showPreferences();
    }
})();
